<template>
  <div class="meals-dialog">
    <el-dialog
      title="查看餐品映射"
      :visible="visible"
      @close="$_close"
      :close-on-click-modal="false"
      custom-class="greater"
    >
      <section class="meals-dialog-body">
        <span>运营商：{{ data.platformName }}</span>
        <span style="margin-left: 114px">品牌：{{ data.brandName }}</span>
        <p style="margin-top: 6px">供应商订阅名称: {{data.supplierSubscribeName}}</p>
        <p style="margin-top: 6px">
          餐品类型：{{ mealTypeObj[productInfo.type] }}
        </p>
        <section style="margin-top: 15px">
          <span>餐品映射详情：</span>
          <el-table :data="[productInfo]" style="width: 100%">
            <el-table-column
              v-for="(item, mealsColIdx) in mealsColumns"
              :key="mealsColIdx"
              :prop="item.prop"
              :label="item.label"
            >
            </el-table-column>
          </el-table>
        </section>
        <!-- 子餐品信息 -->
        <template v-if="productInfo.type === 2">
          <div
            v-for="(childDetailItem,
            childDetailIdx) in productInfo.productGroupItems"
            :key="childDetailIdx"
          >
            <section class="children-class">
              <span>子餐品映射详情：</span>
              <el-table :data="[childDetailItem]" style="width: 100%">
                <el-table-column
                  v-for="(item, childMealsIdx) in mealsColumns"
                  :key="childMealsIdx"
                  :prop="item.prop"
                  :label="item.label"
                >
                </el-table-column>
              </el-table>

              <div class="children-detail">
                <section
                  v-for="(childSku, childSkuIdx) in (childDetailItem &&
                    childDetailItem.skus) ||
                  []"
                  :key="childSkuIdx"
                >
                  <span>子餐品规格映射详情-{{ childSku.title }}：</span>
                  <el-table :data="childSku.items" style="width: 100%">
                    <el-table-column
                      v-for="(item, childSkuColIdx) in skuColumns"
                      :key="childSkuColIdx"
                      :prop="item.prop"
                      :label="item.label"
                    >
                    </el-table-column>
                  </el-table>
                </section>
                <section
                  style="margin-top: 5px;"
                  v-for="(childProp, childPropIdx) in (childDetailItem &&
                    childDetailItem.propertys) ||
                  []"
                  :key="childPropIdx"
                >
                  <span>子餐品属性映射详情-{{ childProp.title }}：</span>
                  <el-table :data="childProp.items" style="width: 100%">
                    <el-table-column
                      v-for="(item, childPropColIdx) in propertyColumns"
                      :key="childPropColIdx"
                      :prop="item.prop"
                      :label="item.label"
                    >
                    </el-table-column>
                  </el-table>
                </section>
              </div>
            </section>
          </div>
        </template>
      </section>

      <section
        v-for="(sku, skuIdx) in productInfo.skus"
        :key="skuIdx"
        class="mt-1"
      >
        <span>餐品规格映射详情-{{ sku.title }}：</span>
        <el-table :data="sku.items" style="width: 100%">
          <el-table-column
            v-for="(item, skuColIdx) in skuColumns"
            :key="skuColIdx"
            :prop="item.prop"
            :label="item.label"
          >
          </el-table-column>
        </el-table>
      </section>

      <section
        v-for="(property, propIdx) in productInfo.propertys"
        :key="propIdx"
        class="mt-1"
      >
        <span>餐品属性映射详情-{{ property.title }}：</span>
        <el-table :data="property.items" style="width: 100%">
          <el-table-column
            v-for="(item, propColIdx) in propertyColumns"
            :key="propColIdx"
            :prop="item.prop"
            :label="item.label"
          >
          </el-table-column>
        </el-table>
      </section>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="$_close()">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mealTypeObj } from "@/pages/index/merchants/meals/constants";
const mealsColumns = [
  { label: "餐品名称", prop: "name" },
  { label: "餐品ID", prop: "pid" },
  { label: "映射名称", prop: "mappingName" },
  { label: "映射ID", prop: "subPid" },
];
const skuColumns = [
  { label: "规格名称", prop: "name" },
  { label: "规格ID", prop: "skuId" },
  { label: "映射名称", prop: "mappingName" },
  { label: "映射ID", prop: "subSkuId" },
];
const propertyColumns = [
  { label: "属性名称", prop: "name" },
  { label: "属性ID", prop: "propertyId" },
  { label: "映射名称", prop: "mappingName" },
  { label: "映射ID", prop: "subPropertyId" },
];
export default {
  name: "meals-dialog",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mealTypeObj,
      mealsColumns,
      skuColumns,
      propertyColumns,
      tableData: [],
      productInfo: {},
    };
  },
  watch: {
    data(val) {
      if (Object.keys(val).length) {
        this.productInfo = val.productInfo || {};
      }
    },
  },
  methods: {
    $_close() {
      this.$emit("update:visible", false);
      this.$emit("update:data", {});
    },
  },
};
</script>

<style lang='scss' scoped>
.meals-dialog {
  /deep/.el-dialog__body {
    padding: 10px 30px;
  }
  /deep/.el-table {
    margin-top: 4px;
  }
  .children-class {
    margin-left: 20px;
    margin-top: 10px;
  }
  .mt-1 {
    margin-top: 10px;
  }
  .children-detail {
    margin-left: 15px;
    margin-top: 5px;
  }
}
</style>